import axios from 'axios';

export default function (context, value) {
    context.commit('set', {loading: true});
    let loading = {
        paymentOperation: true,
        currency: true,
        cash: true,
        paymentAccount: true,
        paymentType: true,
        documentNumber: true,
    };
    context.dispatch('dictionaries/paymentOperation/select/get', {
        cb: () => {
            loading.paymentOperation = false;
            create();
        }
    }, {root: true});
    context.dispatch('dictionaries/currency/select/get', {
        cb: () => {
            loading.currency = false;
            create();
        }
    }, {root: true});
    context.dispatch('dictionaries/cash/select/get', {
        cb: () => {
            loading.cash = false;
            create();
        }
    }, {root: true});
    context.dispatch('dictionaries/paymentAccount/select/get', {
        cb: () => {
            loading.paymentAccount = false;
            create();
        }
    }, {root: true});
    context.dispatch('dictionaries/paymentType/select/get', {
        cb: () => {
            loading.paymentType = false;
            create();
        }
    }, {root: true});
    context.dispatch('get_documentNumber', {
        cb: () => {
            loading.documentNumber = false;
            create();
        }
    });


    function create() {
        for(let k in loading){
            if(loading[k]) return;
        }
        let form = context.getters.form;
        let operation;
        switch (form.ContragentType) {
            case 'partner':
                operation = context.getters.paymentOperation.filter(i=>{return i.value===3})[0];
                break;
            default:
                operation = context.getters.paymentOperation.filter(i=>{return i.value===1})[0];
        }
        context.commit('set', {
            PaymentOperationID: operation.value,
            CategoryId: operation.category,
            PaymentTypeId: operation.type,
            CashId: context.getters.cash[0].value,
            PaymentAccountId: context.getters.paymentAccount[0].value,
            Sum: form.Sum,
            BankCommission: form.BankCommission,
            CurrencyId: form.CurrencyId,
            PaymentDate: new Date().toStringRu(),
            AccountNumber: '',
            Comment: '',
            loading: false,
        });
    }
}
